import { render, staticRenderFns } from "./CircularProgressBar.vue?vue&type=template&id=4fef1704&scoped=true"
import script from "./CircularProgressBar.vue?vue&type=script&lang=js"
export * from "./CircularProgressBar.vue?vue&type=script&lang=js"
import style0 from "./CircularProgressBar.vue?vue&type=style&index=0&id=4fef1704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef1704",
  null
  
)

export default component.exports